import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import packageJson from '../../../../package.json';
import { environment } from '../../../environment/environment';
import { Authentification } from '../../Services/authentification';

@Component({
  selector: 'app-aide',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './aide.html',
  styleUrl: './aide.css',
})
export class Aide {
  readonly appName = packageJson.name;
  readonly appVersion = packageJson.version;
  protected gitVersion = packageJson.gitVersion;
  readonly production = environment.production;

  private readonly auth = inject(Authentification);
  private readonly tick = toSignal(interval(1000));

  protected readonly sessionInfo = computed(() => {
    this.tick();
    const tokenInfo = this.auth.tokenInfoSignal();
    if (!tokenInfo) return null;
    const now = Date.now();
    const iatMs = tokenInfo.iat * 1000;
    const expMs = tokenInfo.exp * 1000;
    const refreshAtMs = iatMs + (expMs - iatMs) * 0.8;
    return {
      nom:              tokenInfo.nom,
      prenom:           tokenInfo.prenom,
      username:         tokenInfo.username,
      roles:            tokenInfo.roles,
      logged:           tokenInfo.logged,
      iatDate:          new Date(iatMs).toLocaleString('fr-FR'),
      expDate:          new Date(expMs).toLocaleString('fr-FR'),
      avantRefresh:     Math.max(0, Math.round((refreshAtMs - now) / 1000)),
      avantExpiration:  Math.max(0, Math.round((expMs - now) / 1000)),
    };
  });

  protected formatDuree(s: number): string {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  }
}
